module.exports = __webpack_public_path__ + "assets/img/36_1497_big.14f6967b.jpg";